import React from 'react'
import { PropScheduleType, ScheduleContent, ScheduleContentBox } from './getScheduleComponent'
import i18n from 'live/services/i18n'
import DatePicker from 'react-datepicker'
import moment from 'moment'
import CustomReactDatepickerInput from 'live/components/forms/ui/custom-react-datepicker-input'
import { ScheduleType } from '../helper/helper'
import { cronToDate, dateToCron } from '../SchedulingHelper'

export function ScheduleDate({ settings, scheduleType, updateSettings }: PropScheduleType): JSX.Element {
    return (
        <ScheduleContent className={'scheduling--scheduleInfo__schedulingSection--dateSelect'}>
            <ScheduleContentBox>
                <div className={'scheduling--scheduleInfo__schedulingSection--dateSelect__datePicker'}>
                    <label>{i18n('Datetime')}</label>
                    <DatePicker
                        customInput={
                            <CustomReactDatepickerInput disabled={settings?.isRecurrent} mask={'11/11/1111 11:11'} />
                        }
                        disabled={scheduleType != ScheduleType.Date}
                        autoComplete={true}
                        selected={cronToDate(settings?.cron)}
                        onChange={date => {
                            if (!settings?.isRecurrent) {
                                try {
                                    const cron = dateToCron(date._d)
                                    updateSettings({ ...settings, cron })
                                } catch (e) {
                                    console.error(e)
                                }
                            }
                        }}
                        maxDate={moment(new Date())}
                        dateFormat={'DD/MM/YYYY HH:mm'}
                        placeholderText={'DD/MM/YYYY HH:mm'}
                        timeIntervals={1}
                        showTimeSelect
                        peekNextMonth
                        showYearDropdown
                        showMonthDropdown
                    />
                </div>
            </ScheduleContentBox>
        </ScheduleContent>
    )
}
